import classNames from "classnames";
import { forwardRef, InputHTMLAttributes } from "react";

import { FieldFeedback, StyledField } from "./Field.styled";

export type FieldProps = InputHTMLAttributes<HTMLInputElement> & {
  /**
   * Set input is invalid
   * @default {false}
   */
  isInvalid?: boolean;

  /**
   * Type for field
   * @type {"textarea"}
   */
  as?: "textarea";
};

const defaultProps = {
  isInvalid: false
};

const FieldComponent = forwardRef<HTMLInputElement, FieldProps>((props, ref) => {
  const { className, isInvalid, as, ...restProps } = props;
  const fieldClass = classNames("c-field", { "is-invalid": isInvalid }, className);

  return <StyledField data-testid="qa-field" ref={ref} as={as as never} className={fieldClass} {...restProps} />;
});

const Field = Object.assign(FieldComponent, {
  defaultProps,

  Feedback: FieldFeedback
});

export default Field;
